import { TranslationsContext } from '@teliaee/telia-translate';
import { ISuggestionItem, LargeSearch, SuggestionField } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../stores/RoamingStore';

interface RoamingCountrySearchProps {
  roamingStore?: RoamingStore;
}

@observer
class RoamingCountrySearch extends React.Component<RoamingCountrySearchProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const { roamingStore } = this.props;
    return (
      <LargeSearch
        id="roaming-large-search"
        align="center"
        formAttributes={{
          onSubmit: (e) => {
            e.preventDefault();
            const suggestions = roamingStore.countrySuggestionItems;
            if (suggestions.length > 0) {
              return roamingStore.selectCountrySuggestionItem(suggestions[0]);
            }
          }
        }}
      >
        <SuggestionField
          id="roaming-search"
          label={translate('roaming.search.placeholder')}
          items={roamingStore.countrySuggestionItems}
          value={roamingStore.countrySuggestionSearchTerm}
          onChange={(input: string) => roamingStore.handleCountryInputChange(input)}
          onSelect={(selectedItem: ISuggestionItem) => {
            return roamingStore.selectCountrySuggestionItem(selectedItem);
          }}
          input={{
            autoComplete: 'off'
          }}
          isClearable={true}
        />
      </LargeSearch>
    );
  }
}

export default inject('roamingStore')(RoamingCountrySearch);
